import { connect } from 'react-redux'
import UnsubscribeView from './UnsubscribeView.jsx'
import { unsubscribeContact, contactUnsubscribe, resubscribeContact, contactResubscribe } from 'src/legacy/redux/actions/rolodex.jsx';
import _ from 'lodash';
import withUseHooks from 'src/legacy/components/withUseHooks.jsx';

const mapStateToProps = (state) => {
  return {
    updating: _.get(state,"legacyRootReducer.rolodex.subscription.updating"),
    subscribed : _.get(state,"legacyRootReducer.rolodex.subscription.subscribed")
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    unsubscribeContact: (id, conversationId, contactKey) =>{
      return dispatch(unsubscribeContact(id, conversationId, contactKey));
    },

    resubscribeContact: (contactId, conversationId, contactKey) =>{
      return dispatch(resubscribeContact(contactId, conversationId, contactKey));
    }
  }
}

const UnsubscribePage = connect(
  mapStateToProps,
  mapDispatchToProps
)(UnsubscribeView)

export default withUseHooks(UnsubscribePage);